// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19 4V2H5V4L19 4ZM21 7.5L3 7.5V5.5L21 5.5V7.5ZM23 9V22H1V9L23 9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-collection-filled')
export default class CollectionFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'collection-filled',
    }
  }
}
